import React from 'react';
import { History } from 'history';
import { Input, InputColor, InputMultiline, InputDate, InputFile, InputSwitch, InputPicklist, Layout, InputSelect, ThemeFont } from '../../components';
import BaseDelete from '../base/base-delete.component'; 
import Model from './app-model';  //editable..
import AddressList from '../address/address-list.component';
import AppService from '../../services/app.service';

interface IProps { 
    history: History;
    root?: string;
}

interface IState {
    datarow: Model;
    errors: any;
}

export default class AppDelete extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);
        this.state = {
            datarow: Model.defaultValue(),
            errors: null,
        }
    }

    private onLoad = (data: any) => {
        this.setState({datarow:  data});
    }

    render() {
        return (
            //editable..
            <BaseDelete history={this.props.history} 
                model={Model} onLoad={this.onLoad} disableCard>              
                
                <Layout history={this.props.history} content={[
                    {caption: 'Details', child: 
                    <>
                    <InputSwitch name='status' label='Status' value={this.state.datarow.status} options={Model.optionStatus} readOnly/>
                    <Input name='name' label='Name' value={this.state.datarow.name} readOnly/>
                    <InputMultiline name='description' label='Description' value={this.state.datarow.description} readOnly/>
                    {AppService.isAppFullVersion() &&
                    <InputPicklist name='owner' label='Owner' value={this.state.datarow.owner} caption={this.state.datarow.ownerCaption} readOnly/>
                    }
                    <InputDate name='expireddate' label='Expired Date' value={this.state.datarow.expireddate} readOnly />
                    <InputColor name='theme.color.primary' label='Primary Color' value={this.state.datarow.theme?.color?.primary} readOnly />
                    <InputColor name='theme.color.secondary' label='Secondary Color' value={this.state.datarow.theme?.color?.secondary} readOnly />
                    <InputColor name='theme.color.info' label='Info Color' value={this.state.datarow.theme?.color?.info} readOnly />
                    <InputColor name='theme.color.success' label='Success Color' value={this.state.datarow.theme?.color?.success} readOnly />
                    <InputColor name='theme.color.warning' label='Warning Color' value={this.state.datarow.theme?.color?.warning} readOnly />
                    <InputColor name='theme.color.error' label='Error Color' value={this.state.datarow.theme?.color?.error} readOnly />
                    <InputSelect name='theme.font' label='Font' value={this.state.datarow.theme?.font} options={ThemeFont} readOnly />
                    <InputFile name='imageUrl' label='Logo' value={this.state.datarow.imageUrl} type='image' readOnly/>
                    </>
                    },
                    {caption: 'Links', child: 
                    this.state.datarow.id > 0 && this.props.history &&
                        <AddressList history={this.props.history} root={this.props.root} caption='Link' parentType='product' parentId={this.state.datarow.id} disableBackButton disableCard/>
                    }
                ]}
                />   
            
            </BaseDelete>
        );
    }
}